<article class="wrapper" [class]="view()">
  <div class="preview-wrapper aw-2-pos--relative aw-2-b--radius-m">

    <!-- Loader -->
    @if (isLoading()) {
      <aw-dots-loader class="aw-2-pos--center-all"/>
    }

    <!-- Image thumbnail -->
    @if (view() === 'image') {
      <img
        class="clickable"
        [hidden]="isLoading()"
        [src]="previewUrl()"
        (load)="imageLoaded()"
        (error)="imageLoadingError()"
        />
    }

    <!-- Icon wrapper -->
    @if (['icon', 'externalFile'].includes(view())) {
      <div
        class="icon-wrapper"
        >
        <aw-file-icon
          [extension]="file().fileExtension"
          [externalProvider]="file().externalProvider"
          [size]="Size.l"
          />
        </div>
      }

      <!-- Actions -->
      <div class="actions-wrapper aw-2-flx aw-2-pos--absolute">
        <!-- Show External File -->
        @if (view() === 'externalFile') {
          <a target="_blank" [href]="file().externalFileUrl">
            <aw-fab-button
              icon="visibility"
              [size]="Size.s"
              [awTooltip]="commonTranslations.view"
              [actionTooltip]="true"
              [showDelay]="200"
              />
            </a>
          }
          <!-- Open Carousel -->
          <aw-fab-button
            icon="search"
            [size]="Size.s"
            [awTooltip]="commonTranslations.preview"
            [actionTooltip]="true"
            [showDelay]="200"
            (click)="onView()"
            />
          </div>
        </div>

        @if (['icon', 'externalFile'].includes(view())) {
          <div
            class="aw-2--flx"
            >
            <p
              class="filename aw-2-txt--truncate aw-2-txt--night aw-2-txt--bold aw-2-flx--flex-1"
              >
              {{ file().name }}
            </p>
            <p
              class="filesize aw-2-txt--steel aw-2-txt--bold"
              >
              {{ file().size | fileSize }}
            </p>
          </div>
        }

      </article>
